import { useCallback, useEffect, useState } from "react";
import io from "socket.io-client";

/**
 * Hook para manejar el socket
 *
 * @param {string} serverPath Ruta del servidor
 * @returns {object} Objeto con el socket, el estado de conexión y las funciones para conectar y desconectar
 */
export const useSocket = (serverPath) => {
  const [socket, setSocket] = useState(null); // Socket
  const [online, setOnline] = useState(false); // Estado de conexión

  /**
   * Conecta el socket
   *
   * @returns {void}
   */
  const conectarSocket = useCallback(() => {
    const token = localStorage.getItem("token");

    /**
     * Conecta el socket
     *
     * @type {object} Socket
     * @property {string} serverPath - Ruta del servidor
     * @property {array} transports - Transportes
     * @property {boolean} autoConnect - Conexión automática
     * @property {boolean} forceNew - Fuerza la nueva conexión
     * @property {object} query - Query
     * @property {string} query.x-token - Token
     * @returns {void}
     */
    const socketTemp = io.connect(serverPath, {
      transports: ["websocket"],
      autoConnect: true,
      forceNew: true,
      query: {
        "x-token": token,
      },
    });

    setSocket(socketTemp);
  }, [serverPath]);

  /**
   * Desconecta el socket
   *
   * @returns {void}
   */
  const desconectarSocket = useCallback(() => {
    socket?.disconnect();
  }, [socket]);

  // Observar el estado de conexión
  useEffect(() => {
    setOnline(socket?.connected);
  }, [socket]);

  // Observar la conexión
  useEffect(() => {
    socket?.on("connect", () => setOnline(true));
  }, [socket]);

  // Observar la desconexión
  useEffect(() => {
    socket?.on("disconnect", () => setOnline(false));
  }, [socket]);

  return {
    socket,
    online,
    conectarSocket,
    desconectarSocket,
  };
};
